/**
 * Canonical icon name list — single source of truth for available icon names.
 *
 * The app's icon registry must map each of these names to an SVG component.
 * Adding or removing an icon here will cause a type error in any registry
 * that doesn't match, keeping them in sync.
 */
export const iconNames = [
  "building",
  "activity",
  "ai",
  "aiOutline",
  "alarm",
  "alarmPause",
  "arrowDown",
  "arrowLeft",
  "arrowRight",
  "arrowUp",
  "bell",
  "bellOffOutline",
  "bellOutline",
  "bug",
  "reportDocument",
  "calendar",
  "calendarAvailable",
  "calendarOutline",
  "calendarRefresh",
  "calendarEvent",
  "call",
  "capture",
  "checkmark",
  "checkmarkOutline",
  "chevronDown",
  "chevronLeft",
  "chevronRight",
  "chevronUp",
  "clock",
  "clockOutline",
  "close",
  "closeCircle",
  "closeCircleFilled",
  "cloudOff",
  "crown",
  "cycle",
  "delete",
  "domain",
  "dot",
  "download",
  "edit",
  "emergency",
  "emergencyOutline",
  "error",
  "errorOutline",
  "event",
  "eventOutline",
  "folderOpen",
  "fullscreen",
  "fullscreenExit",
  "hamburgerMenu",
  "headphones",
  "help",
  "home",
  "homeFilled",
  "hourglass",
  "infinite",
  "info",
  "infoOutline",
  "kebabMenu",
  "list",
  "lockClosed",
  "lockOpen",
  "logout",
  "mail",
  "map",
  "meeting",
  "messageBubble",
  "messageBubbleOutline",
  "messagePending",
  "microphone",
  "minus",
  "motion",
  "move",
  "open",
  "openInNew",
  "pause",
  "pending",
  "personMoving",
  "personShield",
  "pictureOutline",
  "play",
  "playArrow",
  "plus",
  "pricetag",
  "recording",
  "refresh",
  "resume",
  "rotate",
  "search",
  "send",
  "sendOutline",
  "sendRotated",
  "settings",
  "settingsCamera",
  "settingsCameraOutline",
  "settingsOutline",
  "share",
  "shieldSearch",
  "silence",
  "siren",
  "sirenDown",
  "skipNext",
  "skipPrevious",
  "sort",
  "speaker",
  "star",
  "swapVertical",
  "switches",
  "switch",
  "tick",
  "toolbox",
  "toolboxOutline",
  "truck",
  "tune",
  "undo",
  "user",
  "userCircle",
  "userCircleOutline",
  "userOutline",
  "users",
  "video",
  "videoOff",
  "videoOutline",
  "videoRecording",
  "visibility",
  "visibilityOff",
  "volumeOn",
  "volumeOff",
  "wand",
  "warning",
  "warningOutline",
  "watchLive",
] as const;

export type IconName = (typeof iconNames)[number];
